// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressResponse } from './address-response';

/** See com.rev360.pms.api.controller.admin.vendorsandpartners.vendor.VendorResponse */
/* istanbul ignore next */
@GandalfModel
export class VendorResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	accountNumber!: string | null;

	@GandalfProperty({ designType: AddressResponse })
	address!: AddressResponse | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: String })
	directorExternalId!: string | null;

	@GandalfProperty({ designType: String })
	directorName!: string | null;

	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfProperty({ designType: String })
	externalId!: string | null;

	@GandalfProperty({ designType: String })
	externalSource!: string | null;

	@GandalfProperty({ designType: String })
	fax!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	labLocationId!: number | null;

	@GandalfProperty({ designType: String })
	labLocationName!: string | null;

	@GandalfProperty({ designType: String })
	mainPhone!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: Number })
	smartflowMasterSupplierId!: number | null;

	@GandalfProperty({ designType: String })
	tollFree!: string | null;

	@GandalfConstantDecorator(constants.VendorOrderSubmissionMechanism)
	@GandalfProperty({ designType: constants.VendorOrderSubmissionMechanism })
	vendorOrderSubmissionMechanism!: constants.VendorOrderSubmissionMechanism | null;

	@GandalfProperty({ designType: String })
	webSite!: string | null;

}
